/**
 * Container template for a component.
 */

/* Import the component from the component path */
import Component from '../components/CushionForm'

import { connect } from 'react-redux'
import { Dispatch, Action } from 'redux'

/* Import RootStoreState */
import { RootStoreState } from 'modules/root'
// import { saveCurtain } from '../actions'

/* Import module actions */
import * as a from '../../actions'
import * as dtp from 'modules/database/types/cushions'
import * as dt from 'modules/database/types'
import * as s from '../../selectors'

/**
 * Interface for properties that the container passes to the component.
 */
interface Props {
	project: dt.ProjectWithProducts
	productId: dt.ProductID
	formValue: dtp.Cushion
	currentForm?: string
}

/**
 * Interface for action callbacks that the container exposes to the component.
 * The component's `this.props` is typed `Props & Actions`.
 */
interface Actions {
	onChangeFormValue: (newFormValue: dtp.Cushion | undefined) => void
	onChooseProductForm: (form: string) => void
	onNewProduct: (projectId: dt.ProjectID, productType: dt.ProductType) => void
}

export type ComponentProps = Props & Actions

/** Populate the Props from the store state. */
const mapStateToProps = (state: RootStoreState): Props => {
	const project = state.project.currentProject!

	return {
		project,
		productId: state.product.currentProduct!.productId,
		formValue: s.currentProductFormValue(state),
		currentForm: state.product.currentForm,
	}
}

/** Populate the Actions with the callbacks for the component. */
const mapDispatchToProps = (dispatch: Dispatch<Action>): Actions => ({
	onChangeFormValue: (newFormValue: dtp.Cushion | undefined) => {
		if (newFormValue) {
			dispatch(a.updateCurrentProductDetails(newFormValue))
		}
	},
	onChooseProductForm: (form) => {
		dispatch(a.chooseProductForm(form))
	},
	onNewProduct: (projectId, productType) => {
		dispatch(a.newProduct({
			projectId,
			productType,
			navigationReplace: true,
		}))
	},
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)
